import React from 'react';
import { Globe2Icon, DollarSignIcon, ClockIcon, ShieldIcon, FileTextIcon, BadgeCheckIcon, ShoppingCartIcon, CreditCardIcon } from 'lucide-react';
export function Benefits() {
  return <section id="benefits" className="py-16 md:py-24 bg-white" data-id="element-10">
      <div className="container mx-auto px-4" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-13">
            Why Foreign Entrepreneurs Need an ITIN
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-14">
            An Individual Taxpayer Identification Number (ITIN) is essential for
            non-US citizens doing business in America.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-15">
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-16">
            <div className="bg-blue-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-17">
              <ShoppingCartIcon className="text-blue-600" size={24} data-id="element-18" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-19">
              Amazon US Seller Account
            </h3>
            <p className="text-gray-600" data-id="element-20">
              Get an ITIN to open an Amazon US seller account and access the
              massive US e-commerce marketplace.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-21">
            <div className="bg-blue-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-22">
              <Globe2Icon className="text-blue-600" size={24} data-id="element-23" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-24">
              TikTok Shop Access
            </h3>
            <p className="text-gray-600" data-id="element-25">
              Use your ITIN to open a TikTok shop account and tap into the
              rapidly growing social commerce platform.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-26">
            <div className="bg-blue-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-27">
              <CreditCardIcon className="text-blue-600" size={24} data-id="element-28" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-29">
              US Banking Access
            </h3>
            <p className="text-gray-600" data-id="element-30">
              Become eligible to open US bank accounts and apply for credit
              cards as a foreign entrepreneur.
            </p>
          </div>
          
          
        </div>
      </div>
    </section>;
}